import Swal from 'sweetalert2';

// The one error box for people, instead of alert(): says what failed and what to do, never API internals.
export function showError(text: string, title = 'No se pudo completar') {
  return Swal.fire({ icon: 'error', title, text, confirmButtonColor: '#212121', confirmButtonText: 'Entendido' });
}
